module.exports = __webpack_public_path__ + "img/02.96d38e20.png";